export default "__VITE_PUBLIC_ASSET__061418d8__"